import React, { useContext } from "react";
import SettingsTopRow from "./SettingsTopRow";
import { css } from "emotion";
import TitleBlock from "../TitleBlock";
import { GlobalContext } from "../../context/GlobalState";

const ManageUsersMobileHeader = () => {
  const { currentWorkspace } = useContext(GlobalContext);
  return (
    <div className={container}>
      <SettingsTopRow backRoute="settings" />
      <TitleBlock
        title="Users"
        subtitle={currentWorkspace.name.toUpperCase()}
        style="reverse-align"
      />
    </div>
  );
};

export default ManageUsersMobileHeader;

const container = css`
  .reverse-align {
    flex-direction: column-reverse;
  }
`;
